import {Component, Input} from "@angular/core";
import {ProfileService} from "../profile.service";
import {ModalController} from "ionic-angular";
import {ContractModal} from "../../../app/components/contract-modal/contract-modal.component";
import {User} from "../../shared/user/user.model";

@Component({
  selector: 'app-legal-items',
  template: `
    <ion-list>
      <ion-list-header>{{ 'legal.title' | translate }}</ion-list-header>
      <button *ngIf="user.interpreter_status === 'accepted'"
              type="button" ion-item
              (click)="showContract('interpreter')">
        {{ 'contract.interpreter' | translate }}
      </button>
      <a href="https://docs.google.com/document/d/1V6pCftBn-3zh3X_PS4QoXF9ZSO5c4CEM4nGBxKOf5tM/edit?usp=sharing" 
         target="_blank" 
         *ngIf="user.organisation_status === 'accepted'"
         ion-item>
        {{ 'legal.business_terms' | translate }}
      </a>
      <button type="button" ion-item (click)="showContract('privacy')">{{ 'contract.privacy' | translate }}</button>
    </ion-list>
  `,
})
export class LegalItemsComponent{
  @Input('user') user: User;

  constructor(
    private profileService: ProfileService,
    private modalCtrl: ModalController
  ) {
  }

  showContract(type) {
    this.profileService.getContract(type)
      .subscribe(contract => {
        this.modalCtrl
          .create(ContractModal, {
            contract: contract,
            signature: type === 'interpreter' ? contract.signature.webPath : false
          })
          .present();
      });

  }


}



// WEBPACK FOOTER //
// ./src/pages/profile/legal-items/legal-items.component.ts